/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import ArticleCard from "./ArticleCard";
import "../../css/articlegrid.scss";

const ArticleGrid = ({ data }) => (
  <div className="article-grid">
    {data.articles.map((d) => (
      <ArticleCard article={d} image={d.feature} key={d.title} />
    ))}
  </div>
);

ArticleGrid.propTypes = {
  data: PropTypes.shape({
    articles: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        feature: PropTypes.string.isRequired,
      }).isRequired
    ),
  }).isRequired,
};

export default ArticleGrid;
